<template>
  <div>
    <messageBox ref="msgBox" />
    <v-dialog
      persistent
      overlay-opacity="0.6"
      max-width="800"
      :value="publishingChangedDialog"
    >
      <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
          <v-flex md12>
            <v-card class="pa-0 ">
              <v-toolbar color="primary" dark>
                <v-app-bar-nav-icon
                  ><v-icon large>mdi-refresh</v-icon>
                </v-app-bar-nav-icon>

                <v-toolbar-title>Pubblicazione modifiche</v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text>
                <v-row>
                  <v-col cols="11">
                    E' in corso la pubblicazione delle modifiche sul server
                    Aki Digital Solutions....
                  </v-col>
                  <v-col cols="1">
                    <v-progress-circular
                      :indeterminate="true"
                      :rotate="0"
                      :size="32"
                      :width="4"
                      color="light-blue"
                    ></v-progress-circular>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>

    <v-dialog
      persistent
      overlay-opacity="0.6"
      max-width="800"
      :value="sendPrivacyDialog"
    >
      <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
          <v-flex md12>
            <v-card class="pa-0 ">
              <v-toolbar color="primary" dark>
                <v-app-bar-nav-icon
                  ><v-icon large>mdi-refresh</v-icon>
                </v-app-bar-nav-icon>

                <v-toolbar-title>Invio privacy</v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text>
                <v-row>
                  <v-col cols="11">
                   Preparazione ed invio documentazione privacy....
                  </v-col>
                  <v-col cols="1">
                    <v-progress-circular
                      :indeterminate="true"
                      :rotate="0"
                      :size="32"
                      :width="4"
                      color="light-blue"
                    ></v-progress-circular>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>

    <v-dialog
      persistent
      overlay-opacity="0.6"
      max-width="800"
      :value="invoiceDataDialog"
    >
      <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
          <v-flex md12>
            <v-card class="pa-0 ">
              <v-toolbar color="primary" dark>
                <v-app-bar-nav-icon
                  ><v-icon large>mdi-bank</v-icon>
                </v-app-bar-nav-icon>

                <v-toolbar-title>Dati di fatturazione</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon>
                  <v-icon @click="closeInvoiceDataDialog" large
                    >mdi-close</v-icon
                  >
                </v-btn>
              </v-toolbar>

              <v-card-text v-if="invoiceData">
                <v-row
                  ><v-col>Ragione sociale:</v-col
                  ><v-col>{{ invoiceData.company }}</v-col></v-row
                >
                <v-row
                  ><v-col>Indirizzo:</v-col
                  ><v-col>{{ invoiceData.address }}</v-col></v-row
                >
                <v-row
                  ><v-col>Città:</v-col
                  ><v-col>{{ invoiceData.city }}</v-col></v-row
                >
                <v-row
                  ><v-col>CAP:</v-col
                  ><v-col>{{ invoiceData.cap }}</v-col></v-row
                >
                <v-row
                  ><v-col>Codice Fiscale:</v-col
                  ><v-col>{{ invoiceData.fiscal_code }}</v-col></v-row
                >
                <v-row
                  ><v-col>Partita IVA:</v-col
                  ><v-col>{{ invoiceData.vat }}</v-col></v-row
                >
                <v-row
                  ><v-col>Codice univoco:</v-col
                  ><v-col>{{ invoiceData.unique_code }}</v-col></v-row
                >
                <v-row
                  ><v-col>PEC:</v-col
                  ><v-col>{{ invoiceData.pec }}</v-col></v-row
                >
                <v-row
                  ><v-col>E-mail:</v-col
                  ><v-col>{{ invoiceData.mail }}</v-col></v-row
                >
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>

    <v-card class="ma-4">
      <v-toolbar color="primary" dark>
        <v-app-bar-nav-icon
          ><v-icon large>mdi-account-edit</v-icon>
        </v-app-bar-nav-icon>
        <v-toolbar-title>Gestione siti</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <div style="height:10px" />

      <v-row class="ml-2 mr-2">
        <v-col>
          <v-text-field
            outlined
            v-model="filter"
            append-icon="mdi-magnify"
            class="mr-auto ml-1 mr-1 pl-1"
            label="Ricerca"
            hide-details
          />
        </v-col>
      </v-row>

      <div class="vertical-spacer" />
      <v-data-table
        class="grid-table"
        :items-per-page="perPage"
        :must-sort="true"
        :headers="headers"
        :items="sites"
        :options.sync="options"
        :server-items-length="totalSites"
        :loading="loading"
        :footer-props="dataTableFooterOptions"
      >
        <template v-slot:item.actions="{ item }">
          <div v-if="!changingSiteStatus">
            <v-tooltip v-if="!item.disabled" bottom
              ><template v-slot:activator="{ on }"
                ><v-btn
                  :disabled="item.aws_operation_id != null"
                  x-small
                  text
                  icon
                  color="green"
                  @click.stop="startConsolidation(item)"
                  v-on="on"
                  ><v-icon>mdi-play</v-icon></v-btn
                ></template
              ><span>Conferma attivazione</span></v-tooltip
            >

            <v-tooltip bottom
              ><template v-slot:activator="{ on }"
                ><v-btn
                  @click.stop="publishSite(item)"
                  :disabled="!item.finalized"
                  x-small
                  text
                  icon
                  color="error"
                  v-on="on"
                  ><v-icon color="orange">mdi-refresh</v-icon></v-btn
                ></template
              ><span>Pubblica</span></v-tooltip
            >

            <v-tooltip bottom
              ><template v-slot:activator="{ on }"
                ><v-btn
                  :disabled="!item.invoice_data_exist"
                  x-small
                  text
                  icon
                  color="error"
                  v-on="on"
                  @click.stop="getInvoiceData(item.meta_id)"
                  ><v-icon color="primary">mdi-pen</v-icon></v-btn
                ></template
              ><span>Dati fatturazione</span></v-tooltip
            >

            <v-tooltip bottom
              ><template v-slot:activator="{ on }"
                ><v-btn
                  :disabled="!item.invoice_data_exist"
                  x-small
                  text
                  icon
                  color="purple"
                  v-on="on"
                  @click.stop="sendPrivacy(item)"
                  ><v-icon color="primary">mdi-file-document-multiple-outline</v-icon></v-btn
                ></template
              ><span>Invia privacy</span></v-tooltip
            >

            <v-tooltip v-if="item.disabled" bottom
              ><template v-slot:activator="{ on }"
                ><v-btn
                  x-small
                  text
                  icon
                  color="green"
                  @click.stop="disableSite(item)"
                  v-on="on"
                  ><v-icon>mdi-account</v-icon></v-btn
                ></template
              ><span>Sblocca sito</span></v-tooltip
            >

            <v-tooltip v-if="!item.disabled" bottom
              ><template v-slot:activator="{ on }"
                ><v-btn
                  x-small
                  text
                  icon
                  color="orange"
                  @click.stop="disableSite(item)"
                  v-on="on"
                  ><v-icon>mdi-account</v-icon></v-btn
                ></template
              ><span>Disabilita sito</span></v-tooltip
            >

            <v-tooltip bottom
              ><template v-slot:activator="{ on }"
                ><v-btn
                  x-small
                  text
                  icon
                  color="error"
                  @click.stop="removeSite(item)"
                  v-on="on"
                  ><v-icon>mdi-delete</v-icon></v-btn
                ></template
              ><span>Rimuovi sito</span></v-tooltip
            >
          </div>
          <div v-if="changingSiteStatus">
            <v-progress-circular
              :indeterminate="true"
              :rotate="0"
              :size="16"
              :width="2"
              color="light-blue"
            ></v-progress-circular>
          </div>
        </template>

        <template v-slot:item.customer="{ item }">
          {{ item.first_name }} {{ item.last_name }}
        </template>

        <template v-slot:item.disabled="{ item }">
          {{ item.disabled ? "Si" : "No" }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import sitesManager from "../../apis/sites";
import domains from "../../apis/domains";
import staticData from "../../apis/staticData";
import messageBox from "../../components/MessageBox.vue";

export default {
  data() {
    return {
      dataTableFooterOptions: staticData.dataTableFooterOptions,

      sites: [],
      loading: false,
      totalSites: 0,
      options: {
        sortBy: ["last_name"],
        sortDesc: [false],
      },
      headers: [],
      perPage: staticData.defaultPerPage,
      filter: "",
      filters: {},
      invoiceDataDialog: false,
      invoiceData: null,
      changingSiteStatus: false,
      publishingChangedDialog: false,
      sendPrivacyDialog : false,
    };
  },

  components: {
    messageBox,
  },

  mounted() {
    this.headers = [
      { text: "Dominio", align: "left", sortable: true, value: "domain" },
      { text: "Cliente", align: "center", sortable: true, value: "customer" },
      { text: "Email", align: "center", sortable: true, value: "email" },
      {
        text: "Disabilitato",
        align: "center",
        sortable: true,
        value: "disabled",
      },
      { text: "", align: "right", sortable: false, value: "actions" },
    ];

    this.accessesList = [
      { state: null, name: "Tutti" },
      { state: 1, name: "Attivo" },
      { state: 2, name: "Disattivo" },
    ];

    this.accessesList = [
      { state: 1, name: "Attesa conferma" },
      { state: 2, name: "In corso" },
      { state: 3, name: "Registrazione" },
    ];

    this.fetchingData = false;
  },

  watch: {
    options: {
      handler() {
        clearTimeout(this._debounceTimer);
        this._debounceTimer = setTimeout(() => {
          this.reloadSites(true);
        }, 300);
      },
      deep: true,
    },

    filter: {
      handler() {
        clearTimeout(this._debounceTimer);
        this._debounceTimer = setTimeout(() => {
          this.reloadSites(true);
        }, 300);
      },
    },

    filters: {
      handler() {
        clearTimeout(this._debounceTimer);
        this._debounceTimer = setTimeout(() => {
          this.reloadSites(true);
        }, 300);
      },

      deep: true,
      immediate: true,
    },
  },

  methods: {
    reloadSites: function() {
      this.fetchSites()
        .then((data) => {
          this.sites = data.sites;
          this.totalSites = data.totalCount;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    fetchSites() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        let ctx = Object.assign({}, this.options);
        ctx.currentPage = ctx.page;
        ctx.perPage = ctx.itemsPerPage != -1 ? ctx.itemsPerPage : null;
        ctx.filter = this.filter;
        ctx.filters = this.filters;
        ctx.sortBy = ctx.sortBy[0];
        ctx.sortDesc = ctx.sortDesc[0];
        sitesManager
          .fetchSites(ctx)
          .then((result) => {
            this.loading = false;
            resolve(result);
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
            reject();
          });
      });
    },

    removeSite(item) {
      this.$refs.msgBox
        .show(
          "Vuoi davvero confermare la cancellazione del sito ?",
          "Conferma operazione"
        )
        .then(() => {
          sitesManager
            .deleteSite(item.id)
            .then(() => {
              this.reloadSites();
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },

    getInvoiceData(meta_id) {
      sitesManager
        .fetchInvoiceData(meta_id)
        .then((res) => {
          this.invoiceData = res;
          this.invoiceDataDialog = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    disableSite(item) {
      this.changingSiteStatus = true;
      sitesManager
        .disableSite(item)
        .then(() => {
          item.disabled = !item.disabled;
          this.changingSiteStatus = false;
        })
        .catch(() => {});
    },

    closeInvoiceDataDialog() {
      this.invoiceDataDialog = false;
    },

    publishSite(item) {
      this.publishingChangedDialog = true;
      sitesManager
        .publish({
          site: item,
          plesk_domain_id: item.plesk_domain_id,
        })
        .then(() => {
          this.publishingChangedDialog = false;
        })
        .catch((err) => {
          console.log(err);
          this.publishingChangedDialog = false;
        });
    },

    sendPrivacy(item) {
      this.sendPrivacyDialog = true;
      sitesManager
        .sendPrivacy({
          site: item
        })
        .then(() => {
          this.sendPrivacyDialog = false;
        })
        .catch((err) => {
          console.log(err);
          this.sendPrivacyDialog = false;
        });
    },

    startConsolidation(item) {
      domains
        .registerDomain(item.id, item.account_id)
        .then((res) => {
          item.aws_operation_id = res.OperationId;
          this.$refs.msgBox
            .show(
              "Registrazione sito attivata con successo!",
              "Attivazione sito",
              true
            )
            .then(() => {})
            .catch(() => {});
        })
        .catch((err) => {
          console.log(err);
          // this.generalFailure = err;
        });
    },
  },
};
</script>
